export const DELIVERED = 'DELIVERED'
export const SENT = 'SENT'
export const READ = 'READ'
export const FAILED = 'FAILED'
